export default __webpack_public_path__ + "static/media/plus-circle-solid.742ebe50.svg";